import React from "react";
import BulkUploadFile from "../../components/BulkUploadFile";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as BulkUpdatePayoutHoldActions from "../../store/actions/BulkUpdatePayoutHold";

const instructions = [
  "Please provide data as per the format in the sample file.",
  "Please try to open your sample csv file always with MS excel or google sheets but don't open with other editors.",
];

const PayoutHoldBulkUploadDashboard = ({ getBulkUploadUrl }) => {
  return (
    <BulkUploadFile
      instructions={instructions}
      btnDataTestID="PayoutHoldBulkUploadBtn"
      uploadUrl="/driver-accounting/bulk-update-payout-hold"
      sampleURL="/sample/bulk-update-payout-hold.csv"
      id="BulkUpdatePayoutHoldModal"
      sendExtraAck={true}
      keyName="callback_key"
      heading="Bulk Update Payout Hold"
      getUploadUrl={getBulkUploadUrl}
    />
  );
};

function mapDispatchToProps(dispatch) {
  return {
    getBulkUploadUrl: bindActionCreators(
      BulkUpdatePayoutHoldActions.getUploadUrl,
      dispatch
    ),
  };
}

export default connect(null, mapDispatchToProps)(PayoutHoldBulkUploadDashboard);
